import React from 'react'
import classnames from 'classnames'
import { Icons } from '../../Shared/Icons'
import styles from './styles.module.scss'

interface AiDraftSuccessScreenProps {
  message: string
  subtitle: string
  type?: 'success' | 'declined'
}

const AiDraftSuccessScreen: React.FC<AiDraftSuccessScreenProps> = ({ message, subtitle, type = 'success' }) => {
  const renderSubtitle = () => {
    const hasEllipsis = subtitle.endsWith('...')
    const textWithoutEllipsis = hasEllipsis ? subtitle.slice(0, -3) : subtitle
    const subtitleClass = hasEllipsis ? `${styles.subtitle} ${styles.loadingEllipsis}` : styles.subtitle

    return <p className={subtitleClass}>{textWithoutEllipsis}</p>
  }

  const IconComponent = type === 'declined' ? Icons.CloseCircle : Icons.CheckCircle

  return (
    <div className={styles.successScreen} role="status" aria-live="polite">
      <div className={styles.checkmarkContainer}>
        <div
          className={classnames(styles.checkmark, {
            [styles.checkmarkDeclined]: type === 'declined'
          })}
          aria-hidden="true"
        >
          <IconComponent />
        </div>
      </div>
      <div className={styles.messageContainer}>
        <h2 className={styles.message}>{message}</h2>
        {renderSubtitle()}
      </div>
    </div>
  )
}

export default AiDraftSuccessScreen
